import { createFieldBase, FieldBase, FieldBaseArguments } from './FieldBase';

export function createDatePickerField({
  value,
  formatString,
  ...options
}: DatePickerFieldArguments): DatePickerField {
  const fieldBase = createFieldBase(options);

  let self: DatePickerField = {
    ...fieldBase,
    value,
    dateFormat: computeDateFormat(formatString),
    componentType: 'date-picker',
  };

  return self;
}

function computeDateFormat(formatString: string): string {
  switch ((formatString || '').toUpperCase()) {
    case 'DATE':
      return 'dd.MM.yy';
    case 'DATETIME':
      return 'dd.MM.yy HH:mm:ss';
    case 'LONGDATE':
      return 'dd.MM.yyyy';
    default:
      console.error(
        `Unknown format string ${formatString}, returning default format`
      );
      return 'dd.MM.yy';
  }
}



// TYPES:
export interface DatePickerFieldArguments extends FieldBaseArguments {
  value?: string | number | boolean;
  formatString?: string;
}

export interface DatePickerField extends FieldBase {
  componentType: string;
  value?: string | number | boolean;
  dateFormat: string;
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/models/Field/DatePickerField.ts